module.exports = __webpack_public_path__ + "static/media/34DSS7.e884d326.jpg";